import { getCountryCode } from "countries-list";
import { COUPON_TARGETS } from "../../constants/coupon-targets";
import { PRODUCT_TYPE_CODES } from "../../constants/product-types";
import moment from "moment";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Rating } from "primereact/rating";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Flag from "react-world-flags";
import { CURRENCY } from '../../constants/app-constants';
import { DATETIME_FORMATS } from "../../constants/datetime-formats";
import { DISCOUNT_TYPES } from "../../constants/discount-types";
import { PAYMENT_METHODS } from "../../constants/payment-methods";
import { modifyImageUrl } from "../../helpers/formatImageURL";
import { getCurrentLanguage } from "../../helpers/languageHelper";
import useCurrency from "../../hook/useCurrency";
import { getAllAvailableCoupons, getRedemptionCoupon, restoreCoupon } from "../../services/couponService";
import { getPaymentMethods } from "../../services/paymentMethodService";
import onepayImage from "../../stories/assets/onepay.svg";
import stripeImage from "../../stories/assets/stripe.svg";
import vnpayImage from "../../stories/assets/vnpay.svg";
import paypalImage from "../../stories/assets/paypal.png";
import eximbayImage from "../../stories/assets/eximbay.png";
import portoneImage from "../../stories/assets/portone.png";
import paymentwallImage from "../../stories/assets/Paymentwall_Inc.png";
import ClassSchedulePicker from "../common/ClassSchedulePicker";
import LoadingButton from "../common/LoadingButton";
import StudentInformation from "../common/StudentInformation";
import { getI18nLanguageFromLocalStorage, getShoppingCartStateInLocalStorage, removeShoppingCartPaymentSuccessLocalStorage, removeShoppingCartStateFromLocalStorage } from "../../helpers/localStorageHelper";
import { convertCurrency } from "../../helpers/currency";
import { ERROR_CODES } from "../../constants/error-codes";
import KeduLoading from "../loading/KeduLoading";
import { SHOPPING_CART_STEPS } from "../../constants/shopping-cart-constants";
import { getTrainerAvailabilitiesByTrainerPublicId } from "../../services/trainerAvailabilities";
import { getTrainerSchedules } from "../../services/trainersService";
import { getAllTrainerReservationsByPublicId, ReserveSessions, CancelReservations } from "../../services/reservationService";
import { ErrorTemplate, SuccessTemplate } from "../common/ToastMessage/Template";
import { getStudentOrderInfo } from "../../services/shoppingCartService";
import { usePassText } from "../Passes/passI18n";
import PassPromoCard from "../Passes/PassPromoCard";
export default function Payment({ props }) {
  const passText = usePassText();
  const {
    passPromoEnabled,
    passPromoProductCode,
    passPromoOfferEndDate,
    cartDetail,
    defaultCoupon,
    selectedCoupon,
    setSelectedCoupon,
    calculatePrice,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    handlePaymentSubmit,
    translations,
    getRealTimeLecturePrice,
    getProductTypeClass,
    getProductTypeTag,
    showErrorToast,
    getProductNote,
    handleBundleChange,
    isProductType,
    goToStep,
    bundleDiscounts,
    sessionCount,
    setSessionCount,
  } = props;
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [coupons, setCoupons] = useState([]);
  const [selectedTempCoupon, setSelectedTempCoupon] = useState(defaultCoupon);
  const [selectedPromoteCoupon, setSelectedPromoteCoupon] = useState(null);
  const [selectedCouponInList, setSelectedCouponInList] = useState(defaultCoupon);
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const { display, defaultCurrency, ratesData, target } = useCurrency();
  const { originalTotal, subTotal, discountTotal, finalTotal } = calculatePrice();
  const [isPaying, setIsPaying] = useState(false);
  const isPayingRef = useRef(false);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const language = getCurrentLanguage();
  const [loading, setLoading] = useState(false);
  const [trainerAvailabilities, setTrainerAvailabilities] = useState(null);
  const [reservations, setReservations] = useState([]);
  const [trainerSchedules, setTrainerSchedules] = useState([]);
  const [userPublicId, setUserPublicId] = useState(null);
  const [isConfirmSchedule, SetIsConfirmSchedule] = useState(false);
  const scheduleToast = useRef(null);
  const minCheckoutAmount = 1;

  const realTimeTrainerId = useMemo(() =>
    cartDetail?.shoppingCartItems?.find(
      item => item.isSelected && isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
    )?.entityPublicId,
  [cartDetail?.shoppingCartItems, isProductType]);

  useEffect(() => {
    const fetchUserPublicId = async () => {
      try {
        const info = await getStudentOrderInfo();
        if (info?.publicId) setUserPublicId(info.publicId);
      } catch {}
    };
    fetchUserPublicId();
  }, []);

  useEffect(() => {
    if (!realTimeTrainerId) return;
    const fetchData = async () => {
      const [availabilities, reservationsData, schedulesData] = await Promise.all([
        getTrainerAvailabilitiesByTrainerPublicId(realTimeTrainerId),
        getAllTrainerReservationsByPublicId(realTimeTrainerId),
        getTrainerSchedules(realTimeTrainerId),
      ]);
      if (availabilities) {
        if (availabilities.isUnRegisterAvailableTime) {
          setTrainerAvailabilities(null);
        } else {
          const times = JSON.parse(availabilities.availableTimes || '[]');
          setTrainerAvailabilities(times);
        }
      }
      if (reservationsData) {
        const userSelectedSessions = reservationsData.filter(r => r.userPublicId === userPublicId)
        if (userSelectedSessions.length > 0) {
          SetIsConfirmSchedule(true);
        }
        setReservations(reservationsData)
      };
      setTrainerSchedules(schedulesData ?? []);
    };
    fetchData();
  }, [realTimeTrainerId]);

  useEffect(() => {
    if (!userPublicId || !reservations.length) return;
    const userSelectedSessions = reservations.filter(r => r.userPublicId === userPublicId);
    if (userSelectedSessions.length > 0) {
      SetIsConfirmSchedule(true);
      setSessionCount(userSelectedSessions.length);
    }
  }, [userPublicId, reservations, setSessionCount]);

  const handleConfirmSchedule = useCallback(async (times) => {
    try {
      await ReserveSessions({ trainerPublicId: realTimeTrainerId, times });
      SetIsConfirmSchedule(true);
      setSessionCount(times.length);
      scheduleToast.current?.show({
        severity: "success",
        summary: translations.scheduleConfirmedTitle,
        detail: translations.scheduleConfirmedMessage,
        life: 3000,
        content: (props) => SuccessTemplate(props),
      });
    } catch (error) {
      const isConflict = error?.response?.status === 409;
      scheduleToast.current?.show({
        severity: "error",
        summary: isConflict ? translations.scheduleConflictTimeTitle : translations.scheduleConfirmedErrorTitle,
        detail: isConflict ? translations.scheduleConflictTimeMessage : translations.scheduleConfirmedErrorMessage,
        life: 3000,
        content: (props) => ErrorTemplate(props),
      });
    }
  }, [realTimeTrainerId, translations, setSessionCount]);

  const handleCancelSchedule = useCallback(async () => {
    try {
      await CancelReservations(realTimeTrainerId);
      SetIsConfirmSchedule(false);
      scheduleToast.current?.show({
        severity: "success",
        summary: translations.scheduleCancelledTitle,
        detail: translations.scheduleCancelledMessage,
        life: 3000,
        content: (props) => SuccessTemplate(props),
      });
    } catch (error) {
      scheduleToast.current?.show({
        severity: "error",
        summary: translations.scheduleCancelledErrorTitle,
        detail: translations.scheduleCancelledErrorMessage,
        life: 3000,
        content: (props) => ErrorTemplate(props),
      });
    }
  }, [realTimeTrainerId, translations]); // Minimum order amount in USD

  useEffect(() => {
    const fetchData = async () => {
      if (!defaultCoupon || !props.cartDetail || !isProductType || !translations) return;
      setLoading(true);
      try {
        const [couponResponse, paymentResponse] = await Promise.all([
          getAllAvailableCoupons(),
          getPaymentMethods(),
        ]);
        // Only show coupons that can apply to at least one item in the cart
        const cartItems = props.cartDetail?.shoppingCartItems ?? [];
        const filteredCoupons = couponResponse.filter((coupon) => {
          if (coupon.id === 0) return true;
          // Check if coupon can apply to any item in the cart
          return cartItems.some((item) => {
            if (!item || !item.isSelected) return false;
            if (
              coupon.targetContentType === COUPON_TARGETS.VOD &&
              isProductType(item.productTypeId, PRODUCT_TYPE_CODES.VOD_COURSE)
            ) {
              return (
                coupon.applyFor.length === 0 ||
                coupon.applyFor.includes(item.entityPublicId)
              );
            }
            if (
              coupon.targetContentType === COUPON_TARGETS.VOD_SERIES &&
              isProductType(item.productTypeId, PRODUCT_TYPE_CODES.VOD_SERIES)
            ) {
              return (
                coupon.applyFor.length === 0 ||
                coupon.applyFor.includes(item.entityPublicId)
              );
            }
            if (
              coupon.targetContentType === COUPON_TARGETS.TRAINER &&
              isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
            ) {
              return (
                coupon.applyFor.length === 0 ||
                coupon.applyFor.includes(item.entityPublicId)
              );
            }
            return false;
          });
        });
        setCoupons([defaultCoupon, ...filteredCoupons]);

        // Handle payment methods
        const paymentIcons = {
          stripe: stripeImage,
          vnpay: vnpayImage,
          one_pay: onepayImage,
          paypal: paypalImage,
          eximbay: eximbayImage,
          port_one: portoneImage,
          paymentwall: paymentwallImage
        };

        const options = paymentResponse.map((item) => {
          let normalizedCode = item.code.toLowerCase();
          if (normalizedCode.includes("~")) {
            normalizedCode = normalizedCode.split("~")[1];
          }
          return {
            id: item.code,
            normalizedCode,
            paymentIcon: paymentIcons[normalizedCode] || "",
            name:
              translations[`${item.provider.toLowerCase()}Description`] ||
              translations[`${normalizedCode}Description`] ||
              "",
          };
        });

        setPaymentOptions(options);
      } catch (error) {
        setCoupons([defaultCoupon]);
        setPaymentOptions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [defaultCoupon, props.cartDetail, isProductType, translations]);

  useEffect(() => {
    const cartItems = props.cartDetail?.shoppingCartItems ?? [];
    if (cartItems.length === 0) {
      window.location.href = `/${language}/shopping-cart`;
    }
  }, [language, props.cartDetail?.shoppingCartItems]);

  // Auto select first option if not selected
  useEffect(() => {
    if (!selectedPaymentMethod && paymentOptions.length > 0) {
      setSelectedPaymentMethod(paymentOptions[0].id);
    }
  }, [paymentOptions, selectedPaymentMethod, setSelectedPaymentMethod]);

  const getSelectedCartTotal = useCallback((cartDetail) => {
    if (!cartDetail?.shoppingCartItems?.length) return 0;

    return cartDetail.shoppingCartItems
      .filter(item => item.isSelected)
      .reduce((sum, item) => {
        if (item.isPassCovered) return sum;
        const price = isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
          ? getRealTimeLecturePrice(item).discountPrice
          : item.discountPrice;
        return sum + (price || 0);
      }, 0);
  }, [getRealTimeLecturePrice, isProductType]);

  useEffect(() => {
    if (selectedCoupon) {
      const total = getSelectedCartTotal(cartDetail);
      if (total < selectedCoupon.minThreshold) {
        setSelectedTempCoupon(defaultCoupon);
        setSelectedCouponInList(defaultCoupon);
        setSelectedCoupon(defaultCoupon);
      }
    }
  }, [cartDetail, defaultCoupon, selectedCoupon, setSelectedCoupon, getSelectedCartTotal]);

  const [visible, setVisible] = useState(false);
  const applyCouponCode = async () => {
    try {
      // Call API to get coupon details by code
      const matchedCoupon = await getRedemptionCoupon(couponCode);

      // If API returns null or undefined, treat as invalid coupon
      if (!matchedCoupon) {
        showErrorToast(translations.invalidCouponCode);
        return;
      }

      // Check if the coupon can be applied
      if (matchedCoupon.id === 0 || isCouponApplicable(matchedCoupon)) {
        // Apply coupon and reset related states
        setSelectedPromoteCoupon(matchedCoupon);
        setSelectedTempCoupon(defaultCoupon);
        setSelectedCouponInList(defaultCoupon);
        setSelectedCoupon(matchedCoupon);
        setCouponCode("");
      } else {
        // Coupon is valid but not applicable for current cart
        showErrorToast(translations.couponNotApplicable || "Coupon is not applicable for items in the cart");
      }

    } catch (error) {
      // Handle API or network error as invalid coupon
      showErrorToast(translations.invalidCouponCode);
    }
  };

  const handlePayment = async () => {
    if (isPayingRef.current) return;

    isPayingRef.current = true;
    setIsPaying(true);
    try {
      await handlePaymentSubmit();
    } catch (error) {
      console.error(error);
      if (
        error.code === ERROR_CODES.SCRIPT_LOAD_FAILED ||
        error.code === ERROR_CODES.SDK_NOT_READY ||
        error.code === ERROR_CODES.PORTONE_UNKNOWN_ERROR ||
        error.code === ERROR_CODES.IMP_PAYMENT_FAILED ||
        error.code === ERROR_CODES.ERR_NETWORK
      ) {
        showErrorToast(translations.paymentErrorMessage);
      } else if (
        error.code === ERROR_CODES.IMP_REQUEST_FAILED ||
        error.code === ERROR_CODES.PORTONE_REQUEST_FAILED ||
        error.code === ERROR_CODES.PORTONE_FAILURE_TYPE_PG
      ) {
        showErrorToast(translations.processPaymentFailMessage);
      }
      const shoppingCartState = getShoppingCartStateInLocalStorage();
      if (selectedCoupon && selectedCoupon.id !== 0 && shoppingCartState?.orderNumber) {
        await restoreCoupon(shoppingCartState.orderNumber);
      }
      removeShoppingCartStateFromLocalStorage();
      removeShoppingCartPaymentSuccessLocalStorage();
    } finally {
      isPayingRef.current = false;
      setIsPaying(false);
    }
  };

  const isCouponApplicable = (coupon) => {
    if (
      !cartDetail?.shoppingCartItems?.length ||
      !coupon.targetContentType ||
      coupon.applyFor == null ||
      !Array.isArray(coupon.applyFor)
    ) return false;
    const applyForAll = coupon.applyFor.length === 0;
    
    // Check min threshold
    if (coupon.minThreshold && getSelectedCartTotal(cartDetail) < coupon.minThreshold) {
      return false;
    }

    if (coupon.targetContentType === COUPON_TARGETS.VOD) {
      if (applyForAll) {
        return cartDetail.shoppingCartItems.some(i => i.isSelected && isProductType(i.productTypeId, PRODUCT_TYPE_CODES.VOD_COURSE));
      }
      return cartDetail.shoppingCartItems.some(i => i.isSelected && isProductType(i.productTypeId, PRODUCT_TYPE_CODES.VOD_COURSE) && coupon.applyFor.includes(i.entityPublicId));
    }
    if (coupon.targetContentType === COUPON_TARGETS.VOD_SERIES) {
      if (applyForAll) {
        return cartDetail.shoppingCartItems.some(i => i.isSelected && isProductType(i.productTypeId, PRODUCT_TYPE_CODES.VOD_SERIES));
      }
      return cartDetail.shoppingCartItems.some(i => i.isSelected && isProductType(i.productTypeId, PRODUCT_TYPE_CODES.VOD_SERIES) && coupon.applyFor.includes(i.entityPublicId));
    }
    if (coupon.targetContentType === COUPON_TARGETS.TRAINER) {
      if (applyForAll) {
        return cartDetail.shoppingCartItems.some(i => i.isSelected && isProductType(i.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE));
      }
      return cartDetail.shoppingCartItems.some(i => i.isSelected && isProductType(i.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE) && coupon.applyFor.includes(i.entityPublicId));
    }
  };

  const footerContent = (
    <div className="flex justify-content-end p-3">
      <Button
        className="w-full keduall-buttons button-filled-default-normal-primary keduall-typography text-16-semibold-600 h-fit"
        label={translations.applyButtonLabel}
        onClick={() => {
          setSelectedCoupon(selectedTempCoupon);
          setSelectedCouponInList(selectedTempCoupon);
          setSelectedPromoteCoupon(null);
          setVisible(false);
        }}
      />
    </div>
  );

  const formatDateTime = (time) => {
    return moment.utc(time).local().format(DATETIME_FORMATS.DDMMyyyy);
  };

  const onBundleSelect = (item, value) => {
    handleBundleChange(item.id, value);              
    const selectedBundle = bundleDiscounts?.find(b => b.id === value);
    const numberTicket = selectedBundle?.numberTicket ?? 1;

    if (numberTicket !== 1) {
      if (
        !selectedCoupon ||
        selectedCoupon.id === 0 ||
        !selectedCoupon.targetContentType ||
        !selectedCoupon.applyFor ||
        !Array.isArray(selectedCoupon.applyFor)
      ) {
        return;
      }

      const isTrainerCoupon = selectedCoupon.targetContentType === COUPON_TARGETS.TRAINER;

      if (isTrainerCoupon) {
        const applyFor = selectedCoupon.applyFor ?? [];

        let applicable = false;

        if (applyFor.length === 0) {
          applicable = true;
        } else {
          applicable = applyFor.includes(item.entityPublicId);
        }

        if (applicable) {
          setSelectedTempCoupon(defaultCoupon);
          setSelectedCoupon(defaultCoupon);
          setSelectedCouponInList(defaultCoupon);
        }
      }
    }
  };

  const isQuickBuy = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const quickBuy = queryParams.get("isQuickBuy") === "true";
    return quickBuy;
  }

  const isBuyingRealTimeLecture = () => {
    return cartDetail.shoppingCartItems.some(i => i.isSelected && isProductType(i.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE))
  }

  const isDisableCheckout = () => {
    const needsScheduleConfirmation = isBuyingRealTimeLecture();
    const effectiveFinalTotal = finalTotal;
    return !agreeTerms ||
        (cartDetail?.shoppingCartItems.filter(item => item.isSelected) ?? []).length <= 0 ||
        !props.studentInfo.recipientName ||
        !props.studentInfo.email ||
        !!nameError ||
        !!emailError ||
        (effectiveFinalTotal > 0 && effectiveFinalTotal < convertCurrency(minCheckoutAmount, defaultCurrency, target, ratesData)) ||
        (effectiveFinalTotal > 0 && !props.selectedPaymentMethod) ||
        (needsScheduleConfirmation && !isConfirmSchedule)
  }

  return (
    <>
      <Toast ref={scheduleToast} position="bottom-right" className="keduall-toast" />
      {loading ? <KeduLoading /> :
        (cartDetail.shoppingCartItems.filter(item => item.isSelected).length > 0 && <>
          <div className="grid">
            <div className="col-12 lg:col-7 p-3">

              <div className="flex flex-column gap-125">
                <div className="keduall-typography heading-h5-semibold-600 mt-3">
                  {translations.orderedProductsLabel}
                </div>
                <PassPromoCard
                  enabled={passPromoEnabled}
                  productCode={passPromoProductCode}
                  offerEndDate={passPromoOfferEndDate}
                />
                <div className="grid ml-2 mt-1 gap-3">
                  {cartDetail.shoppingCartItems.filter(item => item.isSelected).map((item) => (
                    <div className="col-12 grid grid-nogutter keduall-card product-item-container gap-4 md:gap-0 p-3" key={item.id}>
                      <div
                        className={`col-12 md:col-2 border-round-lg overflow-hidden relative p-0 h-max ${
                          isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
                            ? "aspect-ratio-1-1"
                            : "aspect-ratio-16-9"
                        }`}
                      >
                        {item.thumbnailUrl ? (
                          <img
                            src={modifyImageUrl(item.thumbnailUrl)}
                            alt={item.name}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full flex align-items-center justify-content-center surface-200">
                            <i className="pi pi-ticket keduall-typography text-primary-default"></i>
                          </div>
                        )}
                      </div>

                      <div className="col-12 md:col-10 grid grid-nogutter">
                        <div className="col-12 md:col-8 md:px-4 mb-4 md:mb-0">
                          <span
                            className={`keduall-typography text-12-medium-500 keduall-badge keduall-badge-primary-button ${getProductTypeClass(item.productTypeId)}`}
                          >
                            {getProductTypeTag(item.productTypeId)}
                          </span>
                          <div className="product-name flex align-items-center gap-2 py-2">
                            {isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE) ? (
                              <a
                                href={`/${language}/real-time-lectures/${item.entityPublicId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="keduall-typography text-16-semibold-600 hover:underline"
                              >
                                {item.name}
                              </a>
                            ) : (
                              <span className="keduall-typography text-16-semibold-600">{item.name}</span>
                            )}
                            {isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE) && (
                              <Flag code={getCountryCode(item.trainerCountry)} className="tutor-flag" />
                            )}
                          </div>
                          <div className="flex flex-row justify-content-start align-items-center gap-2">
                            <span className="keduall-typography text-14-normal-400 text-secondary-txt white-space-nowrap text-right w-auto">{getProductNote(item)}</span>

                            {!isProductType(item.productTypeId, PRODUCT_TYPE_CODES.EVENT) && !isProductType(item.productTypeId, PRODUCT_TYPE_CODES.PACKAGE) && !isProductType(item.productTypeId, PRODUCT_TYPE_CODES.DOTORE_PASS) && (
                              <div className="flex gap-2 align-items-center">
                                {/* <Rating className="keduall-rate rate-medium" value={item.rating} readOnly cancel={false} /> */}
                                <i className="pi pi-star-fill class-filter-rating-star"></i>
                                <div className="keduall-typography text-14-normal-400">
                                  {item.rating}
                                </div>
                              </div>
                            )}
                          </div>
                          {/* <div className="mt-1 keduall-typography text-14-normal-400 keduall-text two-row-ellipsis text-secondary-txt">{item.description}</div> */}
                        </div>
                        <div className="col-12 md:col-4 flex md:flex-column justify-content-right align-items-end gap-3">
                          <div className="flex justify-content-right  w-full">
                            <div className="flex flex-column gap-1 justify-content-right  w-full m-auto">
                              <div>
                                {item.discountPercent > 0 && (
                                  <div className="keduall-typography heading-h6-medium-500 keduall-price keduall-original-price text-right w-full overflow-hidden text-overflow-ellipsis">
                                    {isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
                                      ? display(getRealTimeLecturePrice(item).originalPrice, item.currencyCode ?? defaultCurrency)
                                      : display(item.price, item.currencyCode ?? defaultCurrency)}
                                  </div>
                                )}
                                {/* Display the original price with a strikethrough, the discounted price, and the discount amount if a coupon is applied */}
                                {(() => {
                                  if (item.isPassCovered) {
                                    return (
                                      <>
                                        <div className="keduall-typography heading-h6-medium-500 keduall-price keduall-original-price text-right w-full overflow-hidden text-overflow-ellipsis">
                                          {isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
                                            ? display(getRealTimeLecturePrice(item).discountPrice, item.currencyCode ?? defaultCurrency)
                                            : display(item.discountPrice, item.currencyCode ?? defaultCurrency)}
                                        </div>
                                        <div className="keduall-typography heading-h4-semibold-600 keduall-price keduall-final-price text-right w-full overflow-hidden text-overflow-ellipsis">
                                          {display(0, item.currencyCode ?? defaultCurrency)}
                                        </div>
                                        <div className="keduall-typography text-14-normal-400 text-right w-full dp-badge dp-badge-active">
                                          {passText("DOTORE_PASS.LABEL.COVERED_BY_PASS")}
                                        </div>
                                      </>
                                    );
                                  }
                                  const { itemDiscountMap } = calculatePrice();
                                  const discountInfo = itemDiscountMap?.[item.id];
                                  if (discountInfo && discountInfo.discount > 0) {
                                    return (
                                      <>
                                        {item.discountPercent === 0 && discountInfo.originalPrice > 0 && (
                                          <div className="keduall-typography heading-h6-medium-500 keduall-price keduall-original-price text-right w-full overflow-hidden text-overflow-ellipsis">
                                            {display(discountInfo.originalPrice)}
                                          </div>
                                        )}
                                        <div className="keduall-typography heading-h4-semibold-600 keduall-price keduall-final-price text-right w-full overflow-hidden text-overflow-ellipsis">
                                          {display(discountInfo.finalPrice)}
                                        </div>
                                      </>
                                    );
                                  } else {
                                    // If there is no discount, display the original price
                                    return (
                                      <div className="keduall-typography heading-h4-semibold-600 keduall-price keduall-final-price text-right w-full overflow-hidden text-overflow-ellipsis">
                                        {isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
                                          ? display(getRealTimeLecturePrice(item).discountPrice, item.currencyCode ?? defaultCurrency)
                                          : display(item.discountPrice, item.currencyCode ?? defaultCurrency)}
                                      </div>
                                    );
                                  }
                                })()}
                              </div>
                            </div>
                          </div>
                          {/* {isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE) && (
                            <Dropdown
                              id={`dropdown-${item.id}`}
                              name={`dropdown-${item.id}`}
                              value={item.selectedBundleId}
                              options={item.bundleDiscountOptions}
                              onChange={(e) => onBundleSelect(item, e.value)}
                              placeholder={translations.chooseBundleDiscount}
                            />
                          )} */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {!isQuickBuy() && !isBuyingRealTimeLecture() && <Button
                  className="keduall-buttons button-outlined-default-normal-secondary keduall-typography text-14-semibold-600"
                  label={translations.backButtonLabel}
                  onClick={() => {
                    goToStep(SHOPPING_CART_STEPS.SHOPPING_CART);
                  }}
                />}
              </div>
              <div className="flex flex-column gap-125 mt-3">
                <div className="keduall-typography heading-h5-semibold-600">{translations.orderInformation}</div>
                <StudentInformation
                  props={props}
                  nameError={nameError}
                  setNameError={setNameError}
                  emailError={emailError}
                  setEmailError={setEmailError}
                />
              </div>
              {cartDetail.shoppingCartItems.some(item => item.isSelected && isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)) && (
                <div className="keduall-card product-item-container flex flex-column gap-125 mt-3">
                  <ClassSchedulePicker props={{
                    translations,
                    trainerAvailabilities,
                    reservations,
                    trainerSchedules,
                    userPublicId,
                    onConfirmSchedule: handleConfirmSchedule,
                    onCancelSchedule: handleCancelSchedule,
                    isConfirmed: isConfirmSchedule,
                  }} />
                </div>
              )}
            </div>
            <div className="col-12 lg:col-5 p-3">
              <div className="keduall-card py-5 payment-information-container border-round-3xl h-max ">
                <div className="flex flex-column gap-3 px-4 py-3 keduall-typography text-default-txt">
                  {finalTotal > 0 && (
                  <div className="flex flex-column gap-2">
                    <div className="keduall-typography text-16-semibold-600">{translations.selectPaymentMethodLabel}</div>
                    {paymentOptions.length > 0 ? (
                      <div className="flex flex-column gap-3">
                        {paymentOptions.map((option) => (
                          <label
                            key={option.id}
                            htmlFor={`payment-${option.id}`}
                            className={`keduall-card payment-method-container border-round-xl flex justify-content-between align-items-center cursor-pointer px-4 py-0875 gap-4`}
                            onClick={() => setSelectedPaymentMethod(option.id)}
                          >
                            <img
                              src={option.paymentIcon}
                              alt={option.paymentIcon}
                              className="object-cover w-4rem"
                            />
                            <div className="flex-1 keduall-typography text-12-normal-400">
                              {option.name}
                            </div>
                            <input
                              id={`payment-${option.id}`}
                              type="radio"
                              value={option.id}
                              checked={selectedPaymentMethod === option.id}
                              onChange={() => setSelectedPaymentMethod(option.id)}
                              className="keduall-radio checkbox-base radio-white-dot"
                            />
                          </label>
                        ))}
                      </div>
                    ) : (
                      <div className="keduall-typography text-14-normal-400 text-center text-gray-500 py-3">
                        {translations.noPaymentMethodsLabel}
                      </div>
                    )}
                  </div>
                  )}
                  <div className="flex flex-column gap-2">
                    <div className="keduall-typography text-16-semibold-600">{translations.selectCouponLabel}</div>
                    <div className="flex gap-spacing-6">
                      <div className={`keduall-card coupon-card-container flex border-round-xl gap-2 p-075 w-13rem ${selectedCouponInList?.id !== 0 ? 'coupon-checked' : ''}`}>
                        <div className={`${selectedCouponInList?.id !== 0 ? 'h-2rem flex align-items-center' : 'flex align-items-center'}`}>
                          <input className="keduall-radio checkbox-base radio-white-dot" type="radio" value={selectedCouponInList} checked={selectedCouponInList.id !== 0} disabled />
                        </div>
                        {selectedCouponInList?.id !== 0 ? (
                          <div className="flex flex-column gap-2">
                            <div className="flex flex-column gap-1">
                              <div className="keduall-typography heading-h5-semibold-600">
                                {selectedCouponInList.discountType !== DISCOUNT_TYPES.PERCENTAGE ? (
                                  <>{display(selectedCouponInList.discountValue, selectedCouponInList.currency ?? defaultCurrency)}</>
                                ) : (
                                  <>{selectedCouponInList.discountValue}%</>
                                )}
                              </div>
                              <div className="keduall-typography text-14-normal-400">{selectedCouponInList.name}</div>
                            </div>
                            <div className="keduall-typography text-12-medium-500 text-secondary-txt">
                              {!selectedCouponInList.noTimeLimit && selectedCouponInList.endTime ? <>{formatDateTime(selectedCouponInList.endTime)}</> : <>&nbsp;</>}
                            </div>
                          </div>
                        ) : (
                          <div className="keduall-typography text-14-normal-400 text-secondary-txt">{selectedCouponInList?.name}</div>
                        )}
                      </div>
                      <Button
                        className="keduall-buttons button-filled-default-normal-primary keduall-typography text-14-semibold-600 h-fit"
                        label={translations.selectButtonLabel}
                        onClick={() => setVisible(true)}
                      />
                    </div>
                  </div>
                  <div className="flex flex-column gap-125">
                    <div className="flex flex-column gap-1">
                      <div className="keduall-typography text-16-semibold-600">
                        {translations.enterPromotionCodeLabel}
                      </div>
                      <div className="keduall-typography text-12-normal-400 text-dark-txt">
                        {translations.promotionCodeWarning}
                      </div>
                    </div>
                    <div className="flex gap-spacing-6">
                      <div className="flex flex-column gap-3">
                        <InputText
                          className="keduall-form input-default-default keduall-typography text-default-txt w-13rem"
                          name="couponCode"
                          value={couponCode}
                          onChange={(e) => setCouponCode(e.target.value)}
                          placeholder={translations.enterCodeHerePlaceholder}
                        />
                        {
                          selectedPromoteCoupon &&
                          (
                            <div className={`keduall-card coupon-card-container flex border-round-xl gap-2 p-075 w-13rem ${selectedPromoteCoupon ? 'coupon-checked' : ''}`}>
                              <div className="flex flex-column gap-4">
                                <div className="flex flex-column gap-1">
                                  <div className="keduall-typography heading-h3-medium-500">
                                    {selectedPromoteCoupon.discountType !== DISCOUNT_TYPES.PERCENTAGE ? (
                                      <>
                                        {display(selectedPromoteCoupon.discountValue, selectedPromoteCoupon.currency ?? defaultCurrency)}
                                      </>
                                    ) : (
                                      <>
                                        {selectedPromoteCoupon.discountValue}%
                                      </>
                                    )}
                                  </div>
                                  <div className="keduall-typography text-14-normal-400">{selectedPromoteCoupon.name}</div>
                                </div>
                                <div className="keduall-typography text-12-medium-500 text-secondary-txt">
                                  {!selectedPromoteCoupon.noTimeLimit && selectedPromoteCoupon.endTime ? <>{formatDateTime(selectedPromoteCoupon.endTime)}</> : <>&nbsp;</>}
                                </div>
                              </div>
                            </div>
                          )
                        }
                      </div>
                      <Button
                        className="keduall-buttons button-filled-default-normal-primary keduall-typography text-14-semibold-600 h-fit"
                        label={translations.applyButtonLabel}
                        disabled={!couponCode}
                        onClick={() => {
                          applyCouponCode();
                        }}
                      />
                    </div>
                  </div>
                  <div className="flex flex-column gap-125">
                    <div className="flex flex-column gap-3">
                      <div className="flex justify-content-between keduall-typography text-16-semibold-600">
                        <div>{translations.orderDetailsLabel} ({cartDetail.shoppingCartItems.filter(item => item.isSelected).length})</div>
                        <div>
                          {display(originalTotal)}
                        </div>
                      </div>
                      <div className="flex flex-column gap-075">
                        {(cartDetail.shoppingCartItems.filter(item => item.isSelected) ?? []).map((item) => (
                          <div className="flex gap-5 justify-content-between keduall-typography text-16-normal-400" key={item.id}>
                            <div className="flex align-items-center gap-spacing-6">
                              <i className="pi pi-book keduall-typography text-primary-default"></i>
                              <div className="w-12rem keduall-typography text-ellipsis text-12-normal-400">
                                {isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE) ? (
                                  <a
                                    href={`/${language}/real-time-lectures/${item.entityPublicId}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="hover:underline"
                                  >
                                    {item.name}
                                  </a>
                                ) : (
                                  <span>{item.name}</span>
                                )}
                              </div>
                            </div>
                            {isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE) && (
                              <div className="white-space-nowrap keduall-typography text-ellipsis text-12-normal-400">
                                {`${sessionCount}x${display(item.price, item.currencyCode ?? defaultCurrency)} / ${translations.sessionLabel}`}
                              </div>
                            )}

                            <div className="keduall-typography text-ellipsis text-12-normal-400">
                              {isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE) ?
                                display(getRealTimeLecturePrice(item).originalPrice, item.currencyCode ?? defaultCurrency) :
                                display(item.price, item.currencyCode ?? defaultCurrency)}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="flex flex-column gap-3">
                      <div className="keduall-typography text-16-semibold-600">
                        {translations.discountAmountLabel}
                      </div>
                      <div className="flex flex-column gap-075">
                        {(originalTotal !== subTotal) && 
                          <div className="flex gap-5 justify-content-between keduall-typography text-16-normal-400">
                            <div className="flex align-items-center gap-spacing-6">
                              <i className="pi pi-tag keduall-typography text-primary-default"></i>
                              <div className="keduall-typography text-12-normal-400">
                                {translations.systemDiscountLabel}
                              </div>
                            </div>
                            <div className="keduall-typography text-12-normal-400">
                              - {display(originalTotal - subTotal)}
                            </div>
                          </div>
                        }
                        {selectedCoupon && selectedCoupon.id !== 0 && (
                          <div className="flex gap-5 justify-content-between keduall-typography text-16-normal-400">
                            <div className="flex align-items-center gap-spacing-6">
                              <i className="pi pi-tag keduall-typography text-primary-default"></i>
                              <div className="keduall-typography text-12-normal-400">
                                {selectedCoupon.name}
                              </div>
                            </div>
                            <div className="keduall-typography text-12-normal-400">
                              - {display(discountTotal)}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="flex justify-content-between">
                      <div className="keduall-typography heading-h6-semibold-600">{translations.totalPaymentAmountLabel}</div>
                      <div className="keduall-typography heading-h6-semibold-600 text-primary-default">
                        {display(finalTotal)}
                      </div>
                    </div>
                    <div className="flex gap-2 align-items-center">
                      <input
                        type="checkbox"
                        id="terms"
                        name="terms"
                        checked={agreeTerms}
                        onChange={(e) => setAgreeTerms(e.target.checked)}
                      />
                      <label htmlFor="terms" className="keduall-checkbox checkbox-base checkbox-small">
                        <i className="pi pi-check"></i>
                      </label>
                      <label className="required">
                        {translations.reviewOrderAndAgreeToPaymentLabel}
                      </label>
                    </div>
                  </div>
                  { finalTotal > 0 && finalTotal < convertCurrency(minCheckoutAmount, defaultCurrency, target, ratesData) && (
                    <div className="keduall-typography text-14-normal-400 text-danger-txt border-round-xl p-2 keduall-card warning-message-container">
                      {translations.minimumOrderAmountLabel.replace("{{amount}}", display(minCheckoutAmount, defaultCurrency))}
                      <span
                        onClick={() => {
                          const language = getI18nLanguageFromLocalStorage();
                          window.location.href = `/${language}/vod`;
                        }} 
                        className="ml-1 cursor-pointer keduall-typography text-14-semibold-600 text-default-txt"
                      >
                        {translations.hereLabel}
                      </span>
                    </div>
                  )}
                  <div className="flex justify-content-end">
                    <LoadingButton
                      className="pc-only keduall-buttons button-filled-default-normal-primary keduall-typography text-16-semibold-600 h-fit w-16rem py-3 px-125"
                      label={translations.payButtonLabel}
                      disabled={isDisableCheckout()}
                      onClick={handlePayment}
                      loading={isPaying}
                    />

                    <LoadingButton
                      className="mt-3 w-full mobile-only keduall-buttons button-filled-default-normal-primary keduall-typography text-16-semibold-600 h-fit py-3 px-125"
                      label={translations.payButtonLabel}
                      disabled={isDisableCheckout()}
                      onClick={handlePayment}
                      loading={isPaying}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Dialog
            header={translations.selectCouponLabel}
            visible={visible}
            onHide={() => setVisible(false)}
            className="keduall-dialog coupon-modal-container w-26rem"
            footer={footerContent}
            blockScroll={true}
            baseZIndex="10001"
            draggable={false}
          >
            <div className="keduall-dialog coupon-list-container keduall-scrollbar flex flex-column gap-3">
              {coupons.map((coupon) => {
                const applicable = coupon.id === 0 ? true : isCouponApplicable(coupon);
                return (
                  <div
                    className={`keduall-card coupon-card-container flex border-round-xl gap-2 p-075 w-100 ${selectedTempCoupon.id === coupon.id ? 'coupon-checked' : ''} ${coupon.id !== 0 && !applicable ? 'coupon-disabled opacity-50 cursor-auto' : 'cursor-pointer'}`}
                    key={coupon.id}
                    onClick={() => {
                      if (coupon.id !== 0 && !applicable) return;
                      setSelectedTempCoupon(coupon);
                    }}
                  >
                    <div className={`${coupon.id !== 0 ? 'h-2rem flex align-items-center' : 'flex align-items-center'}`}>
                      <input className="keduall-radio checkbox-base radio-white-dot" type="radio" value={coupon} checked={selectedTempCoupon.id === coupon.id} disabled={coupon.id !== 0 && !applicable}/>
                    </div>
                    {coupon.id !== 0 ? (
                      <div className="flex flex-column gap-2">
                        <div className="flex flex-column gap-1">
                          <div className="keduall-typography heading-h5-semibold-600">
                            {coupon.discountType !== DISCOUNT_TYPES.PERCENTAGE ? (
                              <>{display(coupon.discountValue, coupon.currency ?? defaultCurrency)}</>
                            ) : (
                              <>{coupon.discountValue}%</>
                            )}
                          </div>
                          <div className="keduall-typography text-14-normal-400">{coupon.name}</div>
                        </div>
                        <div className="keduall-typography text-12-medium-500 text-secondary-txt">
                          {!coupon.noTimeLimit && coupon.endTime ? <>{formatDateTime(coupon.endTime)}</> : <>&nbsp;</>}
                        </div>
                      </div>
                    ) : (
                      <div className="keduall-typography text-14-normal-400 text-secondary-txt">{coupon.name}</div>
                    )}
                  </div>
                );
              })}
            </div>
          </Dialog>
        </>)
      }
    </>
  );
}
